import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "2.573",
  height: "19.94",
  fill: "#606365",
  rx: "1",
  transform: "matrix(.70841 .7058 -.70841 .7058 14.177 0)"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  width: "2.573",
  height: "19.94",
  fill: "#ABB9BF",
  rx: "1",
  transform: "matrix(.70841 -.7058 .70841 .7058 0 1.926)"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }